export default [
  {
    text: 'Асфальтированная дорога',
    value: 'asphalt',
  },
  {
    text: 'Грунтовая дорога',
    value: 'ground',
  },
  {
    text: 'Нет',
    value: 'no',
  },
];
